import React from 'react'
import { Box, Divider, Typography } from '@material-ui/core'
import CircularLoaderSong from 'Components/SongComponents/CircularLoaderSong/CircularLoaderSong'
import StatusPrompt from 'Components/Pages/Services/FormationDashboard/StatusPrompt/StatusPrompt'
import { TaxExemptionStatusQuery } from 'TypeDefs/TaxExemptionStatusTracker'
import useStyles from './styles'
import StatusTracker from '../StatusTracker/StatusTracker'

type Props = {
  loading: boolean
  data: TaxExemptionStatusQuery | undefined
}
const TaxExemptionStatusContainer = ({ loading, data }: Props) => {
  const classes = useStyles()

  return (
    <Box>
      <Box borderRadius={4} minHeight={375} className={classes.box} mb={3}>
        <Typography className={classes.title} variant='h5'>
          Tax Exemption Status Tracker
        </Typography>
        <Divider variant='fullWidth' className={classes.divider} />

        <Box className={classes.carouselContainer}>
          {loading || !data ? (
            <Box height={281} m='auto' display='flex' alignItems='center'>
              <CircularLoaderSong />
            </Box>
          ) : (
            <StatusTracker
              currentStatus={data?.getTaxExemptionStatus?.status}
            />
          )}
        </Box>
      </Box>
      {!loading &&
        data &&
        data?.getTaxExemptionStatus?.status === 'GATHERING_INFORMATION' && (
          <Box mb={3} borderRadius={4}>
            <StatusPrompt currentStatus={data?.getTaxExemptionStatus?.status} />
          </Box>
        )}
    </Box>
  )
}

export default TaxExemptionStatusContainer
